<div class="linq-dialog">
	<div class="linq-dialog__header">
		<div class="col">
			<h3 class="linq-heading">Load Saved Report Filter</h3>
		</div>
	</div>
	<div class="linq-dialog__content linq-dialog__content_scroll">
		<sl-table [data]="entityData" [config]="config" [filters]="filters"></sl-table>
	</div>
	<mat-dialog-actions class="linq-dialog__actions">
		<button class="linq-button linq-button--secondary" (click)="cancel()" mat-stroked-button>
			Cancel
		</button>
		<span class="spacer"></span>
	</mat-dialog-actions>
</div>